"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropsKind = void 0;
var PropsKind;

(function (PropsKind) {
  PropsKind["counters"] = "counters";
  PropsKind["objectList"] = "object-list";
  PropsKind["alertTargetList"] = "alert-target-list";
  PropsKind["keyValue"] = "key-value";
  PropsKind["dnList"] = "dn-list";
  PropsKind["yaml"] = "yaml";
  PropsKind["table"] = "table";
  PropsKind["links"] = "links";
  PropsKind["teleportation"] = "teleportation";
  PropsKind["config"] = "config";
  PropsKind["ruleAssistant"] = "rule-assistant";
  PropsKind["workloadsHealth"] = "workloads-health";
  PropsKind["podHealth"] = "pod-health";
  PropsKind["podsVersionsHealth"] = "pods-versions-health";
})(PropsKind = exports.PropsKind || (exports.PropsKind = {}));